import styled from 'styled-components/macro';
import tw, { theme } from 'twin.macro'

export const FooterTopSection = styled.div`
  ${tw`col-span-4 lg:col-span-12`};
  align-items: center;
  color: ${theme`colors.white`};
  display: grid;
  margin: 40px 0;
  
  @media screen and (min-width: 1024px) {
    display: flex;
    height: 100px;
    justify-content: space-between;
    margin: 0;
  }
  
  img {
    margin: 0 auto 30px auto;
    width: 100%;
    max-width: 400px;
    
    @media screen and (min-width: 1024px) {
      margin: 0;
      width: 400px;
    }
  }

  p {
    font-size: 14px;
    text-align: center;
    
    @media screen and (min-width: 1024px) {
      font-size: 16px;
    }
  }
`

export const FooterJobCode = styled.div`
  ${tw`col-span-4 lg:col-span-12`};
  color: ${theme`colors.white`};
  font-size: 14px;
  padding: 20px 0;
  text-align: center;

  @media screen and (min-width: 1024px) {
    text-align: left;
  }
`